import type { IHealthRepository } from "@src/domain/system/repository/health_repository";
import { GetHealthUseCase } from "./get_health.usecase";

/**
 * Health Service
 * Aggregates all health-related use cases
 */
export class HealthService {
    private getHealthUseCase: GetHealthUseCase;

    constructor(healthRepository: IHealthRepository) {
        this.getHealthUseCase = new GetHealthUseCase(healthRepository);
    }

    async getHealth() {
        return this.getHealthUseCase.execute();
    }
}
